import React from 'react'
import { useParams } from 'react-router-dom'
import ProjectExpenseForm from './ProjectExpenseForm'

const ProjectExpenseView = () => {
  const { id } = useParams()

  return (
    <ProjectExpenseForm 
      mode="view" 
      expenseId={id}
    />
  )
}

export default ProjectExpenseView

